import React, { SetStateAction } from 'react';
import * as TFF from '@tff/types/TFF';
import BookingCards from './BookingCards';
import NDCCostOverview from './NDCCostOverview';
import { ConfirmationFooter } from './ConfirmationFooter';

interface ConfirmationPageProps {
  originalJourneys: TFF.Journey[];
  newBookingJourneys: TFF.Journey[];
  isRoundTrip: boolean;
  fareDifference: number;
  taxAmount: number;
  penalty: number;
  baseAmount: number;
  selectedOffer: TFF.CombinationOffer | undefined;
  rebookCloser: (fn: SetStateAction<boolean>) => void;
  handleConfirmation: () => void;
  setServiceFee: React.Dispatch<SetStateAction<string>>;
  serviceFee: string;
}

const ConfirmationPage: React.FC<ConfirmationPageProps> = ({
  originalJourneys,
  newBookingJourneys,
  isRoundTrip,
  fareDifference,
  taxAmount,
  penalty,
  baseAmount,
  rebookCloser,
  handleConfirmation,
  selectedOffer,
  setServiceFee,
  serviceFee,
}) => {
  const handleConfirmationClick = () => {
    if (selectedOffer) {
      handleConfirmation();
    }
  };

  return (
    <div>
      <BookingCards
        originalJourneys={originalJourneys}
        newBookingJourneys={newBookingJourneys}
        isRoundTrip={isRoundTrip}
        fareDifference={fareDifference}
      />
      <NDCCostOverview
        originalJourneys={originalJourneys}
        newBookingJourneys={newBookingJourneys}
        isRoundTrip={isRoundTrip}
        totalAmount={fareDifference}
        taxAmount={taxAmount}
        penalty={penalty}
        baseAmount={baseAmount}
        serviceFee={serviceFee}
        setServiceFee={setServiceFee}
      />
      <ConfirmationFooter rebookCloser={rebookCloser} handleConfirmationClick={handleConfirmationClick} />
    </div>
  );
};

export default ConfirmationPage;
